import { AddressProtocolType } from '../enums';

export const getConnectionMethods = [
    { value: AddressProtocolType.DHCP, name: 'Automatic / DHCP', dataPw: 'wifi_automatic_option' },
    { value: AddressProtocolType.STATIC, name: 'Manual / Static', dataPw: 'wifi_manual_option' },
];
